/* eslint-disable */
import { toastConfig } from 'config';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Button, Col, Form, Input, Row } from 'antd';
import FileUpload from 'components/inputs/FileUpload';
import DetailPageHeader from 'components/header/DetailPageHeader';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Box, Button as MuiButton, Chip, Dialog, DialogContent, Grid, Stack } from '@mui/material';
import moment from 'moment';
import ConfirmModal from 'components/modal/ConfirmModal';
import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useGetRecentConversationMutation, useSendControlDataMutation } from 'store/features/api/apiSlice';
import ListViewControlSelfAssurance from './ListViewControlSelfAssurance';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CardAccordion from 'components/CardAccordion/CardAccordion';
import useGetStateFromParams from 'static-solutions/hook/useGetStateFromParams';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import { decodeQueryParamData } from 'utils/utils';

function ControlSelfAssurance() {
	const { id } = useParams();

	const [item, setItem] = useState({});
	const [rerender, setRerender] = useState(0);
	const [dataList, setDataList] = useState([]);
	const [openModal, setOpenModal] = useState(false);

	const [GetQueryV3, { data: queryV3Data, isUninitialized, isLoading }] = useGetRecentConversationMutation();

	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const handleModalOpen = () => {
		setOpenModal(true);
	};

	const handleModalClose = () => {
		setOpenModal(false);
	};

	const paramsData = useMemo(() => {
		if (id) {
			return decodeQueryParamData(id);
		} else {
			return null;
		}
	}, [id]);

	useEffect(() => {
		if (companyCode) {
			GetQueryV3({
				companyCode,
				fieldCodes: ['companyCode', 'ownerUserId', 'assurerUserId'],
				fieldValues: [companyCode, userId, userId],
				name: 'ConsoleControlQuestionnaire',
			});
		}
	}, [companyCode, rerender]);

	useEffect(() => {
		if (queryV3Data?.results?.length > 0) {
			const data = queryV3Data?.results?.map((item) => {
				return {
					id: item?.id,
					controlId: item?.controlId,
					expectation: item?.expectation,
					effectiveDate: item?.effectiveDate,
					controlDomain: item?.controlDomain,
					controlSubDomain: item?.controlSubDomain,
					controlQuestion: item?.controlQuestion,
					effectiveWorkingHours: item?.effectiveWorkingHours,
					deadlineDaysCount: item?.deadlineDaysCount,
					assurerName: item?.assurerName,
					ownerName: item?.ownerName,
					frequency: item?.frequency,
					actual: item?.actual,
					remark: item?.remark,
					answerDueDate: item?.answerDueDate,
					evidence: item?.evidence,
					evidenceAttachment: item?.evidenceAttachment,
					submissionDateTime: item?.submissionDateTime,
					ownerUserId: item?.ownerUserId,
					assurerUserId: item?.assurerUserId,
					answerStatus: item?.answerStatus,
					controlCategory: item?.controlCategory,
					reportingPeriod: item?.reportingPeriod,
					rootCause: item?.rootCause,
					resolutionTimeline: item?.resolutionTimeline,

					// entryTime: item.entryTime,
					// exitTime: item.exitTime,
					// shiftLength: item.shiftLength,

					// dateString: item.dateString,
					// employeeId: item.employeeId,
					// positionName: item.positionName,
					// earliestExitTimeline: item.earliestExitTimeline,
					// effectiveWorkingHours: item.effectiveWorkingHours,
					// marker: item.marker,
					// shiftName: item.shiftName,
					// overtime: item.overtime,
					// entryTime: item.entryTime,
					// exitTime: item.exitTime,
					// shiftLength: item.shiftLength,
				};
			});
			setDataList(data);
		}
	}, [queryV3Data]);

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<DetailPageHeader image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />} title={paramsData?.processName ?? ''} />
				</Grid>

				<Grid item xs={12}>
					<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
						<ListViewControlSelfAssurance
							data={dataList}
							isLoading={isLoading && !isUninitialized}
							showModal={handleModalOpen}
							setItem={setItem}
						/>
					</Box>
				</Grid>
			</Grid>
			{openModal && (
				<NotificationModal
					item={item}
					setItem={setItem}
					data={dataList}
					showModal={openModal}
					setRerender={setRerender}
					handleClose={handleModalClose}
				/>
			)}
		</>
	);
}

export default ControlSelfAssurance;

function NotificationModal({ item: id, setItem, data, showModal, handleClose, setRerender }) {
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [sendControlData, { isLoading, isSuccess, isError }] = useSendControlDataMutation();

	const [actualValue, setActualValue] = useState('');
	const [confirmModal, setConfirmModal] = useState(false);
	const theme = useTheme();
	// const { state } = useLocation();
	const { state } = useGetStateFromParams();
	const userId = useSelector((state) => state.profile.profileData.userId);
	// const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const [isRemarkVisible, setRemarkVisible] = useState(false);
	const [question, setQuestion] = useState(null);
	const [payload, setPayload] = useState(null);
	const [pagination, setPagination] = useState({
		currentPage: 0,
		firstPage: 0,
		lastPage: 0,
	});
	const [screenSize, setScreenSize] = useState('md');

	const handleSubmit = (submittedData) => {
		const refinedSubmitedData = {
			id: submittedData.id,
			data: {
				actual: submittedData.actual ?? '',
				remark: submittedData.remark ?? '',
				evidence: submittedData.evidence ?? '',
				rootCause: submittedData.rootCause ?? '',
				resolutionTimeline: submittedData.resolutionTimeline ?? '',
				evidenceAttachment: submittedData.evidenceAttachment ?? [],
			},
			action: 'submit',
		};
		const convertJson = JSON.stringify(refinedSubmitedData);
		const convertBase64 = btoa(convertJson);

		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitAnswer',
		});

		setConfirmModal(true);
	};

	const handleAction = (action) => {
		const refinedSubmitedData = {
			id,
			action,
		};
		const convertJson = JSON.stringify(refinedSubmitedData);
		const convertBase64 = btoa(convertJson);
		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitAnswer',
		});
		setConfirmModal(true);
	};

	const currentUserIdentity = (id, data) => {
		const currentItem = data.find((item) => item.id === id);
		if (currentItem?.ownerUserId === userId && currentItem?.answerStatus?.toLowerCase() === 'answer submitted') {
			return 'LoginAsOwner';
		} else if (currentItem?.assurerUserId === userId && ['answer pending', 'answer rejected'].includes(currentItem?.answerStatus?.toLowerCase()))
			return 'LoginAsAssurer';
		else return 'LoginAsOther';
	};

	const onModalOkHandler = () => {
		if (payload) {
			sendControlData(payload);
		}
	};

	const actualChangeHandler = (e) => {
		const expectation = question?.expectation?.toLowerCase();
		const remark = e.target.value.toLowerCase();

		setActualValue(e.target.value?.toLowerCase());

		if (remark?.length < 1) return;
		else if (expectation === remark) setRemarkVisible(false);
		else setRemarkVisible(true);
	};

	const onPreHandler = () => {
		if (pagination.currentPage > 0) {
			const prevPageIndex = pagination.currentPage - 1;
			if (prevPageIndex > -1 && pagination.lastPage) {
				setQuestion(data[prevPageIndex]);
				setItem(data[prevPageIndex].id);
			} else setQuestion(null);

			setPagination((prev) => ({
				...prev,
				currentPage: prevPageIndex,
			}));
		}
	};

	const onNextHandler = () => {
		if (pagination.currentPage < pagination.lastPage) {
			const nextPageIndex = pagination.currentPage + 1;

			if (nextPageIndex > -1 && pagination.lastPage) {
				setQuestion(data[nextPageIndex]);
				setItem(data[nextPageIndex].id);
			} else setQuestion(null);

			setPagination((prev) => ({
				...prev,
				currentPage: nextPageIndex,
			}));
		}
	};

	useEffect(() => {
		if (isSuccess) {
			toast.success('Success! Action completed ', toastConfig);

			setRerender((prev) => prev + 1);
			handleClose();
			setPayload(null);
		} else if (isError) {
			toast.error('Failed! Action not completed', toastConfig);
			// form.resetFields();
			setPayload(null);
		}
	}, [isSuccess, isError]);

	useEffect(() => {
		if (data?.length > 0 && id) {
			const currentItemIndex = data?.findIndex((item) => item.id === id);
			if (currentItemIndex > -1) setQuestion(data[currentItemIndex]);
			setPagination({
				currentPage: currentItemIndex,
				firstPage: 0,
				lastPage: data?.length - 1,
			});
		}
	}, []);

	useEffect(() => {
		if (!state?.processCode) {
			navigate(-1);
		}
	}, [state]);

	return (
		<>
			<Dialog
				fullWidth={true}
				open={showModal}
				maxWidth={screenSize}
				aria-labelledby="announcement-modal"
				fullScreen={screenSize === 'full' ? true : false}
				sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
			>
				<ViewEditModalHeader
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
					viewType={false}
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
					headerTitle={question?.actual ? 'View Control Self-Assurance' : 'Provide Control Self-Assurance'}
				/>

				<DialogContent>
					{question === null ? (
						<Box>Loading...</Box>
					) : (
						<Form form={form} layout="vertical" requiredMark={false} validateTrigger={['onChange', 'onBlur']} onFinish={handleSubmit}>
							<Form.Item noStyle name="id" initialValue={question.id} />
							<CardAccordion
								title="Control Information"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 24]}>
									<Col xs={5}>
										<DisplayComponent label="Control Questionnaire" head={true} />
									</Col>
									<Col xs={19}>
										<Chip
											label={question?.controlQuestion}
											variant="outlined"
											sx={{
												width: '100%',
												justifyContent: 'start',
												fontWeight: 600,
												background: '#f2f2f2',
												borderColor: '#e2ebf7',
											}}
										/>
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Control Domain" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.controlDomain} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Control Sub-Domain" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.controlSubDomain} />
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Control ID" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.controlId} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Control Category" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.controlCategory ?? ''} sx={{ textTransform: 'capitalize' }} />
									</Col>
								</Row>
							</CardAccordion>

							{/* <Col xs={24}>
								<Divider sx={{ my: 2 }} />
							</Col> */}

							<CardAccordion
								title="Assurance Information"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 24]}>
									<Col xs={5}>
										<DisplayComponent label="Control Assurer" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.assurerName} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Control Owner" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.ownerName} />
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Assurance Frequency" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={`${question?.frequency}`} sx={{ textTransform: 'capitalize' }} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Assurance Period" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.reportingPeriod ?? ''} sx={{ textTransform: 'capitalize' }} />
									</Col>
								</Row>
							</CardAccordion>

							{/* <Col xs={24}>
								<Divider sx={{ my: 2 }} />
							</Col> */}

							<CardAccordion
								title="Self-Assurance"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 24]}>
									<Col xs={5}>
										<DisplayComponent label="Assurance Due Date" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={moment(question?.answerDueDate).format('DD MMMM YYYY')} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Assurance Date" head={true} />
									</Col>
									<Col xs={6}>
										{question?.submissionDateTime ? (
											<Chip
												label={moment(question?.submissionDateTime).format('DD MMMM YYYY')}
												variant="outlined"
												sx={{
													bgcolor: '#f2f2f2',
													color: moment(question?.answerDueDate).isAfter(moment(question?.submissionDateTime))
														? '#000D1A'
														: '#bb2222',
													fontWeight: 600,
													width: '100%',
													borderColor: '#e2ebf7',
													justifyContent: 'start',
												}}
											/>
										) : (
											<Chip
												label={moment(question?.submissionDateTime).format('DD MMMM YYYY')}
												variant="outlined"
												sx={{
													background: '#f2f2f2',
													color: moment(question?.answerDueDate).isAfter(moment(question?.submissionDateTime))
														? '#000D1A'
														: '#bb2222',
													fontWeight: 400,
													width: '100%',
													borderColor: '#e2ebf7',
													justifyContent: 'start',
												}}
											/>
										)}
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Assurance Expectation" head={true} />
									</Col>
									<Col xs={6}>
										<DisplayComponent label={question?.expectation} />
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Actual Assurance" head={true} />
									</Col>
									<Col xs={6}>
										{question?.actual ? (
											<Chip
												label={question?.actual}
												variant="outlined"
												sx={{
													bgcolor: question?.expectation !== question?.actual ? '#ffe2e2' : '#dbf7e2',
													color: question?.expectation !== question?.actual ? '#bb2222' : '#30653d',
													fontWeight: 600,
													width: '100%',
													borderColor: '#e2ebf7',
													justifyContent: 'start',
												}}
											/>
										) : (
											<Box sx={{ '& .ant-form-item': { marginBottom: 0 } }}>
												<Form.Item
													name="actual"
													rules={[
														{
															required: true,
															message: 'Field is required',
														},
													]}
												>
													<Input
														autoComplete="off"
														placeholder="Write here"
														onBlur={actualChangeHandler}
														disabled={question?.assurerUserId !== userId}
														style={{
															height: '32px',
															borderRadius: '4px',
															color:
																actualValue === 'no'
																	? '#bb2222'
																	: actualValue === 'yes'
																		? 'rgb(48, 101, 61)'
																		: '#000',
														}}
													/>
												</Form.Item>
											</Box>
										)}
									</Col>

									<Col xs={5}>
										<DisplayComponent label={isRemarkVisible ? 'Reason for Deviation' : 'Remarks if any'} head={true} />
									</Col>
									<Col xs={19}>
										{question?.actual ? (
											<DisplayComponent label={question?.remark} />
										) : (
											<Box sx={{ '& .ant-form-item': { marginBottom: 0 } }}>
												<Form.Item
													name="remark"
													rules={[
														{
															required: isRemarkVisible ? true : false,
															message: 'Field is required',
														},
													]}
												>
													<Input
														autoComplete="off"
														placeholder="Write here"
														disabled={question?.assurerUserId !== userId}
														style={{ height: '32px', borderRadius: '4px' }}
													/>
												</Form.Item>
											</Box>
										)}
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Root Cause" head={true} />
									</Col>
									<Col xs={6}>
										<CustomTextInput
											form={form}
											name="rootCause"
											value={question?.rootCause}
											style={{ marginBottom: 0 }}
											disabled={question?.actual || question?.assurerUserId !== userId ? true : false}
										/>
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Resolution Timeline" head={true} />
									</Col>
									<Col xs={6}>
										<Box sx={{ '& .ant-form-item': { marginBottom: 0 } }}>
											<CustomTextInput
												form={form}
												name="resolutionTimeline"
												style={{ marginBottom: 0 }}
												value={question?.resolutionTimeline}
												disabled={question?.actual || question?.assurerUserId !== userId ? true : false}
											/>
										</Box>
									</Col>

									<Col xs={5}>
										<DisplayComponent label="Assurance Evidence" head={true} />
									</Col>
									<Col xs={6}>
										<Box sx={{ '& .ant-form-item': { marginBottom: 0 } }}>
											{question?.actual ? (
												<DisplayComponent label={question?.evidence} />
											) : (
												<Box sx={{ '& .ant-form-item': { marginBottom: 0 } }}>
													<Form.Item name="evidence">
														<Input
															autoComplete="off"
															placeholder="Write here"
															disabled={question?.assurerUserId !== userId}
															style={{ height: '32px', borderRadius: '4px' }}
														/>
													</Form.Item>
												</Box>
											)}
										</Box>
									</Col>

									<Col xs={5} offset={2}>
										<DisplayComponent label="Evidence Attachment" head={true} />
									</Col>
									<Col xs={6}>
										{question?.actual || question?.assurerUserId !== userId ? (
											<Box
												sx={{
													'& .ant-form-item': { marginBottom: 0 },
													'& .ant-upload-select': {
														display: 'block',
														width: '100% !important',
													},
												}}
											>
												<FileUpload
													disabled={true}
													name="evidenceAttachment"
													processCode={state?.processCode}
													existingFieldList={question?.evidenceAttachment}
												/>
											</Box>
										) : (
											<Box
												sx={{
													'& .ant-form-item': { marginBottom: 0 },
													'& .ant-upload-select': {
														display: 'block',
														width: '100% !important',
													},
												}}
											>
												<FileUpload name="evidenceAttachment" processCode={state?.processCode} />
											</Box>
										)}
									</Col>
								</Row>
							</CardAccordion>

							<Row gutter={[16, 24]}>
								<Col xs={24}>
									<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
										<Box>
											{/* {!question?.actual && ( */}
											<>
												{currentUserIdentity(id, data) === 'LoginAsOwner' && (
													<>
														<MuiButton
															type="button"
															htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: 'rgb(3, 57, 108)',
																color: 'common.white',
																width: '6rem',
																'&:hover': { bgcolor: 'rgb(3, 57, 108)' },
															}}
															onClick={() => handleAction('approve')}
														>
															Approve
														</MuiButton>
														<MuiButton
															type="button"
															// htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: theme.palette.lynTheme.delete,
																color: 'common.white',
																width: '7rem',
																'&:hover': { bgcolor: theme.palette.lynTheme.delete },
															}}
															onClick={() => handleAction('reject')}
														>
															Reject
														</MuiButton>
													</>
												)}

												{currentUserIdentity(id, data) === 'LoginAsAssurer' && (
													<Button type="primary" htmlType="submit" disabled={isLoading}>
														Submit
													</Button>
												)}
											</>
											{/* )} */}
										</Box>
										<Stack direction="row" justifyContent="right" sx={{ mb: 2, gap: '5px' }}>
											<Button onClick={onPreHandler} disabled={pagination?.currentPage < 1}>
												<CaretLeftOutlined />
											</Button>
											{/* <Chip label={`Page ${pagination?.currentPage + 1} / ${pagination?.lastPage + 1}`} variant="outlined" /> */}
											<Button onClick={onNextHandler} disabled={pagination?.currentPage >= pagination?.lastPage}>
												<CaretRightOutlined />
											</Button>
										</Stack>
									</Stack>
								</Col>
							</Row>
						</Form>
					)}
				</DialogContent>
			</Dialog>

			{confirmModal && (
				<ConfirmModal
					icon={false}
					modalData={{ head: 'Confirmation' }}
					showModal={confirmModal}
					setShowModal={setConfirmModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</>
	);
}

function DisplayComponent({ label, head = false, sx }) {
	return (
		<Chip
			label={label}
			variant="outlined"
			sx={{
				width: '100%',
				justifyContent: 'start',
				fontWeight: head ? 600 : 400,
				bgcolor: head ? '#edf7ff' : '#f2f2f2',
				borderColor: '#e2ebf7',
				...sx,
			}}
		/>
	);
}
